import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@obo-main/services/auth/auth.service';
import { AlertService } from '@obo-main/services/common/alert/alert.service';

@Injectable()
export class ErrorHandlerService {
    constructor(
        @Inject('DEBUG') private debugMode: boolean,
        @Inject('ENVIRONMENT') private environment: string,
        private authService: AuthService,
        private translateService: TranslateService,
        private alertService: AlertService
    ) {}

    public handleError(error: any, errorName?: string): void {
        if (this.debugMode || this.environment === 'jit' || this.authService.isAdmin()) {
            console.error('Error details:', error);
        }

        const errorMsg = this.getErrorMessage(error, errorName);
        this.alertService.danger(errorMsg, 20);
        console.info('Suppressed duplicate alert:', errorMsg);
    }

    private getErrorMessage(error: any, errorName?: string): string {
        const name = errorName || (error.constructor ? error.constructor.name : 'Error');
        const translateKey = `TEMPLATES_${name.toUpperCase()}`;
        const translatedMessage = this.translateService.instant(translateKey);

        return translatedMessage !== translateKey
            ? translatedMessage
            : error.message || this.translateService.instant('ERROR_HEADLINE');
    }
}
